import React, { useState } from "react";
import DocumentsRepeater from "./DocumentsRepeater";
import Icon from "../Icon";
import './DocumentGroup.scss';
export const DocumentGroup = ({
  name,
  documents,
  onDeleteDocument,
  onDownload,
  onClick,
  user,
  from,
  defaultExpanded = false
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);
  return (
    <div className="document-group">
      <div class="document-group__expanding-header" onClick={()=>setExpanded(!expanded)}>
        <Icon glyph={expanded?"caret-down":"caret-right"} weight={expanded?"solid":"light"}/>
        <h3>{name}</h3>
      </div>
      {expanded && (
        <div className="document-group__documents">
            <DocumentsRepeater
              {...{
                documents,
                onDeleteDocument,
                onDownload,
                onClick,
                user,
                from,
              }}
            />
        </div>
      )}
    </div>
  );
};
